import React, {useState} from 'react'

export default function CustomStepper({ Data ,showOnlyValue=false}) {
    const [showHovered,setShowHovered] =useState(null)
    return (
        <>
            <div className='StepperOption' style={{ marginTop: '30px' }}>
                {
                    Data?.length > 0 ? Data?.map((val, id) => {
                        return (
                            <>
                                <div className='main-single-content'>
                                    <div className={`boxed ${val?.yellowBox ? "yellowBox" : ""}`}
                                    onMouseEnter={()=>setShowHovered(val)}
                                    onMouseLeave={()=>setShowHovered(null)}
                                    >
                                        {
                                            showOnlyValue ? 
                                            <h6 style={{fontSize:'16px'}}>{val?.value}</h6>
                                            :
                                            <h6>{val?.value} <br/> {val?.subValue}</h6>
                                        }
                                    </div>
                                    <h5>{val?.name?.split(" ").map((word, index) => (
                                        <React.Fragment key={index}>
                                            {word}
                                            {index === 0 && <br />}
                                            {index !== 0 && " "}
                                        </React.Fragment>
                                    ))}</h5>

                                    <div className='custom-hover-card-content'>

                                    </div>
                                </div>
                            </>
                        )
                    })
                        : ""}
            </div>
        </>
    )
}
